import { Box, Card } from '@zillow/constellation-10';
import { LoadingButton, LoadingTag, LoadingText } from '@zg-rentals/loading-components';

type ActiveCardSkeletonProps = {
  icon: React.ReactNode;
};

export const ActiveCardSkeleton = ({ icon }: ActiveCardSkeletonProps) => {
  return (
    <Card
      elevated={false}
      data-testid="ActiveCardSkeleton"
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '{spacing.default} {spacing.loose} {spacing.loose}',
        flex: 1,
        height: '100%',
      }}
    >
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: 'tighter',
          paddingBottom: 'default',
          borderBottom: '{borderWidths.default} solid {colors.gray.300}',
          width: '100%',
        }}
      >
        {icon}
        <LoadingText isLoading>Loading</LoadingText>
      </Box>

      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 'tighter',
          padding: '{spacing.default} 0',
          flexGrow: 1,
          width: '100%',
        }}
      >
        <LoadingTag isLoading loadingWidth="25%">
          Tag
        </LoadingTag>

        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'micro.default',
            width: '100%',
          }}
        >
          <LoadingText isLoading>Loading</LoadingText>
        </Box>
      </Box>

      <Box
        css={{
          display: 'flex',
          gap: 'tighter',
          width: '100%',
        }}
      >
        <LoadingButton isLoading css={{ flex: 1 }} size="sm">
          Action
        </LoadingButton>
      </Box>
    </Card>
  );
};
